import { useTranslation } from 'react-i18next';

const LANG_KEY = 'lang';

const useLanguage = () => {
  const { i18n } = useTranslation();

  const setLanguage = (lang: string) => {
    void i18n.changeLanguage(lang);
    localStorage.setItem(LANG_KEY, lang);
  };

  return { language: i18n.language, setLanguage };
};

export default useLanguage;
